import { Component } from '@angular/core';
import { WcagDirective } from './wcag.directive';

@Component({
    selector: 'app-wcag',
    templateUrl: './wcag.component.html',
    styleUrls: ['./wcag.component.css'],
    imports: [WcagDirective],
    standalone: true
})
export class WcagComponent { }